import React, { useCallback, useEffect, useRef, useState } from "react";

import { Col, Layout, message, Row } from "antd";

import { smallFormItemLayout, tailFormItemLayout } from "../../utils/Layouts";

import { useSelector } from "react-redux";

import axios from "axios";
import { sumBy } from "lodash";
import moment from "moment";
import Container from "../../commons/Container";
import FormHeader from "../../commons/FormHeader";
import MemorizeTable from "../../commons/MemorizeTable";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import ReportButtons from "../../commons/ReportButtons";
import {
  authenticateAdmin,
  authenticateOwner,
} from "../../utils/authentications";
import ReportFooter from "../../utils/ReportFooter";
import ReportHeading from "../../utils/ReportHeading";
import numberFormat from "../../utils/numberFormat";
import SelectTagFieldGroup from "../../commons/SelectTagsFieldGroup";
import { onBranchSearch, onWarehouseSearch } from "../../utils/utilities";
import { onChange } from "../../utils/form_utilities";
import round from "../../utils/round";

const { Content } = Layout;

const url = "/api/sales/";
const title = "Average Sales per Pax per Day";

const initialValues = {
  period_covered: [moment().startOf("day"), moment().endOf("day")],
  branches: [],
  is_excel: false,
};
export default function AverageSalesPerPaxPerDay({
  other_set = false,
  history,
}) {
  const [records, setRecords] = useState([]);
  const auth = useSelector((state) => state.auth);
  const [state, setState] = useState(initialValues);

  const [loading, setLoading] = useState({
    search: false,
    download: false,
  });
  const [options, setOptions] = useState({
    suppliers: [],
    stocks: [],
    purchase_orders: [],
    warehouses: [],
  });
  const report = useRef(null);

  const getReport = useCallback(({ ...form_data }) => {
    if (form_data.period_covered) {
      setLoading({
        search: !form_data.is_excel,
        download: form_data.is_excel,
      });
      axios
        .post(`${url}average-sales-per-pax-per-day`, form_data)
        .then((response) => {
          if (response.data) {
            if (form_data.is_excel) {
              return window.open(`/public/reports/${response.data.filename}`);
            }
            setRecords(response.data.records);
          }
        })
        .catch((err) => {
          message.error("There was an error processing your request");
        })
        .finally(() => {
          setLoading({
            search: false,
            download: false,
          });
        });
    } else {
      message.warning("Period Covered is Required");
    }
  }, []);

  useEffect(() => {
    let authenticate = other_set ? authenticateOwner : authenticateAdmin;

    authenticate({
      role: auth.user?.role,
      history,
    });
  }, [auth.user]);

  return (
    <Content style={{ padding: "0 50px" }}>
      <FormHeader breadcrumb_items={["Reports", title]} />
      <Container title={title}>
        <Row>
          <Col span={12}>
            <RangeDatePickerFieldGroup
              label="Period Covered"
              name="period_covered"
              value={state.period_covered}
              onChange={(dates) =>
                setState((prevState) => ({
                  ...prevState,
                  period_covered: dates,
                }))
              }
              formItemLayout={smallFormItemLayout}
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <SelectTagFieldGroup
              label="Branches"
              value={state.branches}
              onSearch={(value) => {
                onBranchSearch({ value, setOptions });
              }}
              onChange={(value) => {
                onChange({
                  key: "branches",
                  value,
                  setState,
                });
              }}
              formItemLayout={smallFormItemLayout}
              options={(options.branches || []).map((o) => {
                return {
                  label: o.name,
                  value: o.name,
                };
              })}
            />
          </Col>
        </Row>

        <ReportButtons
          loading={loading}
          onSearch={() => getReport({ ...state })}
          onDownload={() => getReport({ ...state, is_excel: true })}
          report={report}
          formItemLayout={tailFormItemLayout}
        />

        <div ref={report}>
          <div className="report-heading">
            <ReportHeading />
            <span className="has-text-weight-bold">{title}</span>
            <br />
            {state.period_covered?.[0] &&
              state.period_covered?.[1] &&
              `${moment(state.period_covered?.[0]).format("ll")} - ${moment(
                state.period_covered?.[1]
              ).format("ll")} `}{" "}
            <br />
            Printed By : {auth.user.name} <br />
            Date/Time Printed : {moment().format("LLL")}
          </div>

          <MemorizeTable dependencies={[records]}>
            <div className="report-container">
              <table>
                <thead>
                  <tr>
                    <th>DATE</th>
                    <th className="has-text-right">NET </th>
                    <th className="has-text-right">PAX</th>
                    <th className="has-text-right">AVG</th>
                  </tr>
                </thead>
                <tbody>
                  {records.map((record, index) => (
                    <tr key={index}>
                      <td className="has-text-centered">{record.date}</td>
                      <td className="has-text-right">
                        {numberFormat(record.amount)}
                      </td>
                      <td className="has-text-right">{record.pax}</td>
                      <td className="has-text-right">
                        {round(record.average)}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <th></th>
                    <th className="has-text-right">
                      {numberFormat(sumBy(records, (o) => o.amount))}
                    </th>
                    <th className="has-text-right">
                      {sumBy(records, (o) => o.pax)}
                    </th>
                    <th className="has-text-right">
                      {numberFormat(
                        sumBy(records, (o) => o.amount) /
                          sumBy(records, (o) => o.pax)
                      )}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </MemorizeTable>

          <div className="report-heading m-t-1">
            <ReportFooter />
          </div>
        </div>
      </Container>
    </Content>
  );
}
